import parlors from "@/constants/parlors_detail.json";

export const getParlorInfoByRegionCode = (sidoCode: number, sigunguCode?: number) => {
  if (sigunguCode) {
    const sigunguParlorList = parlors.filter(
      (parlor) => String(parlor.sigungu) === String(sigunguCode),
    );

    if (sigunguParlorList.length) {
      return { regionParlors: sigunguParlorList, hasSigunguParlor: true };
    }
  }

  const sidoParlorList = parlors.filter((parlor) => String(parlor.sido) === String(sidoCode));

  return { regionParlors: sidoParlorList, hasSigunguParlor: false };
};
